module.exports = __webpack_public_path__ + "img/feature-title-xl.1aaee7bc.png";